<template>
    <div ref="projectsPage" class="projects-page">
        <section class="projects">
            <h2 class="text-muted kursiv">
                <TerminalSimulator 
                    referrer="projects.head" 
                    text="Phantasie, und Kreativität haben keine Grenzen..."
                    :isWritten="pageLoadingStore.isLoaded('projects.head')" 
                    @textIsWritten="()=>pageLoadingStore.setLoaded('projects.head',true)"
                />
            </h2>
            <br>
            <div class="projects-body">
                <!-- Tank.da  -->
                <div class="card" style="width: 18rem;">
                    <img :src="require(`@/assets/img/tankda.png`)" class="card-img-top" alt="Tank.da" width="250px" height="250px">
                    <div class="card-body">
                        <h5 class="card-title">Tank.da</h5>
                        <p class="card-text">Ist ein Projekt, dass ich mir entwickelt habe, um meine javascript,und allgemeine Webentwicklung 
                            Kenntnisse zu befestigen, bzw. zu vertiefen.</p>
                        <a href="https://tankda.azadbarkho.de" target="_blank" class="btn btn-secondary">Tank.Da</a>
                    </div>
                </div>

                <!-- Tank.da Android -->
                <div class="card" style="width: 18rem;">
                    <img :src="require(`@/assets/img/tankda-app.png`)" class="card-img-top" alt="Tank.da" width="250px" height="250px">
                    <div class="card-body">
                        <h5 class="card-title">TankDa Android-App</h5>
                        <p class="card-text">Dieses Projekt ist eine native Version vom Tank.da für Android Geräte. Das Projekt habe ich mit React-Native (Expo) realisiert.</p>
                        <a href="https://play.google.com/store/apps/details?id=com.tankda&gl=DE" target="_blank" class="btn btn-secondary">Tank.Da</a>
                    </div>
                </div>
                
                <!-- Subnetz-Rechner  -->
                <div class="card" style="width: 18rem;">
                    <img :src="require(`@/assets/img/subnetz-rechner.png`)" class="card-img-top" alt="subnetz-rechner" width="250px" height="250px">
                    <div class="card-body">
                        <h5 class="card-title">Subnetz-Rechner</h5>
                        <p class="card-text">Dieses Projekt habe ich im Rahmen der Projektwoche bei der Umschulung entwickelt. 
                            Es wurde mit PHP-Symfony realiesiert.</p>
                        <a href="https://subnetz-rechner.azadbarkho.de/" target="_blank" class="btn btn-secondary">Subnetz-Rechner</a>
                    </div>
                </div>

                <!-- Visible-Pot -->
                <div class="card" style="width: 18rem;">
                    <img :src="require(`@/assets/img/visible-pot.webp`)" class="card-img-top" alt="Tank.da" width="250px" height="250px">
                    <div class="card-body">
                        <h5 class="card-title">Visible-Pot</h5>
                        <p class="card-text">Dieses Projekt habe ich während meines Praktikums für Dsa-Marketing entwickelt als native (DSGVO-konforme) lösung gegen Formular-Spams.</p>
                        <a href="/contact" target="_blank" class="btn btn-secondary">Visible Pot</a>
                    </div>
                </div>
                
            </div> 
        </section>
    </div>
</template>

<script>
    import TerminalSimulator from '../components/TerminalSimulator.vue';
    import { usePageLoadingStore } from '../stores/pageLoadingStore.js';

    export default {
        __name: 'ProjectsPage',
        data() {

        },
        setup(){
            const pageLoadingStore = usePageLoadingStore();

            return {
                pageLoadingStore
            }
        },
        components:{
            TerminalSimulator
        }
    }
</script>

<style scoped>

.projects-page{
    color: rgb(255, 255, 255);
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bolder;
    font-family: orbitron;
    position: absolute;
    top: 50%;
    bottom: 50%;

}
.projects {
    text-align: center;
    /* color: #303032; */
    opacity: 0.97;
    height: 100vh;
    margin-top: 200px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    .text-muted{
        font-size: x-large;
        color: white !important;
    }
}

.projects-body {
  display: flex;
  justify-content: space-evenly;
  gap: 20px;
  padding-bottom: 100px;
}

.card{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    background-color: black;
    color: white !important;

    .card-img-top{
        height: 270px;
    }

    .card-body{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 10px;

        .card-title{
            font-size: larger;
        }

        .card-text{
            font-size: large
        }
    }

    img{
        object-fit: cover;
    }
}

@media only screen and (max-width: 1250px) {
  .projects-body {
    flex-wrap: wrap;
    gap: 15px;
  }
}
@media only screen and (max-width: 700px) {
  .projects-body {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

</style>
